import { setCookie, getCookie, getCurrentDomain } from "./cookie";
import { getDeviceId, DEVICE_KEY, DEVICE_COOKIE_MAX_AGE } from "./device";
import { getAndRefreshSessionId } from "./session";
import { convertUTCDateToLocalDate } from "./date";
import { uuidV4 } from "./uuid";
import { jonify } from "./jonify";
import { slugify } from "./slugify";
import { QueueOfFunctions } from "./queue";
import { createApi } from "./create-api";
import { ValidationError } from "./errors";
import { countWords } from "./string/count-words";
import { useInterval } from "./hooks/use-interval";
import { useIsMobileScreen } from "./hooks/use-is-mobile-screen";
import { useLocalStorage } from "./hooks/use-local-storage";
import { useSessionStorage } from "./hooks/use-session-storage";
import { useDebounceValue } from "./hooks/use-debounce-value";
import { useDebounceCallback } from "./hooks/use-debounce-callback";
export {
  DEVICE_COOKIE_MAX_AGE,
  DEVICE_KEY,
  QueueOfFunctions,
  ValidationError,
  convertUTCDateToLocalDate,
  countWords,
  createApi,
  getAndRefreshSessionId,
  getCookie,
  getCurrentDomain,
  getDeviceId,
  jonify,
  setCookie,
  slugify,
  useDebounceCallback,
  useDebounceValue,
  useInterval,
  useIsMobileScreen,
  useLocalStorage,
  useSessionStorage,
  uuidV4
};
